import { render } from "./ListingCard.vue?vue&type=template&id=56584742&scoped=true"
import script from "./ListingCard.vue?vue&type=script&lang=js"
export * from "./ListingCard.vue?vue&type=script&lang=js"

import "./ListingCard.vue?vue&type=style&index=0&id=56584742&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56584742"]])

export default __exports__